import { Buffer } from 'buffer';
import miscHelper from 'general/helpers/miscHelper';

// Hàm resize ảnh bằng canvas
function resizeImage(file, targetWidth) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target.result;
    };

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const scale = targetWidth / img.width;
      const width = targetWidth;
      const height = img.height * scale;

      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob((blob) => {
        const resizedFile = new File([blob], file.name, {
          type: file.type,
          lastModified: Date.now(),
        });
        resolve(resizedFile);
      }, file.type);
    };

    img.onerror = reject;
    reader.onerror = reject;

    reader.readAsDataURL(file);
  });
}

class MyUploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  async upload() {
    const file = await this.loader.file;
    const resizedFile = await resizeImage(file, 200);

    const response = await miscHelper.callApiUploadFile(resizedFile);
    console.log('check response: ', response);

    let url = '';
    if (response?.length > 0 && response[0]?.relativePath) {
      url = response[0].relativePath;
    }

    const baseURL = process.env.REACT_APP_DOMAIN_URL;

    const base64 = Buffer.from(await resizedFile.arrayBuffer(), 'binary').toString('base64');

    return {
      default: url
        ? `${baseURL}/${url}`
        : `data:${resizedFile.type.toLowerCase()};base64,${base64}`,
    };
  }
}

export default function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    return new MyUploadAdapter(loader);
  };
}
